var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editable)?_c('div',[_c('textarea',_vm._b({staticClass:"border rounded p-2 w-100",attrs:{"rows":"5"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'textarea',_vm.$attrs,false))]):_c('div',[_vm._v("\n    "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }